import { z } from 'zod';
import api from '~/utils/api';
import { ClaimType } from '~/utils/constants';
import { makeLineItemClaimLoaderWithReason, redirect } from '~/utils/routing';

const paramsSchema = z.object({
  idFromPlatform: z.string(),
  claimType: z.nativeEnum(ClaimType),
  store: z.string(),
});

export const { loader, useLoaderData: useFollowUpData } =
  makeLineItemClaimLoaderWithReason(
    ({
      context: {
        claim,
        settings: { storefrontId },
        order,
      },
      params,
    }) => {
      const { claimType, store } = paramsSchema.parse(params);

      return api
        .calculateAfterReasonSelection({
          params: { storefrontId },
          body: {
            id: claim.lineItem.id,
            claimType: claim.claimType,
            calculatedLineItems: [
              {
                originalStoreOrderLineItemId: claim.lineItem.id,
                quantity: claim.quantity,
                grams: claim.grams,
                unitPrice: claim.unitPrice,
                unitTax: claim.unitTax,
                comments: claim.comments,
                reasonId: claim.reason.id,
                reasonCategoryCode: claim.reason.category,
                reasonDetailId: claim.reason.detail?.id,
              },
            ],
          },
        })
        .then(({ eventPolicyEnforcement }) =>
          eventPolicyEnforcement ?
            {
              eventPolicyEnforcement,
              orderId: order.idFromPlatform,
              claimType,
              store,
            }
            // return a redirect with the event custom fields if it exists
          : redirect('../meta'),
        );
    },
  );
